import { createSlice } from "@reduxjs/toolkit";
import { getProfile, updateProfile, updateProfilePicture,
  getExperience, addExperience, updateExperience, deleteExperience,
  getSkills, addSkills, updateSkills, deleteSkills, verifyOTP
} from './thunk';
export const initialState = {
  profile: {},
  experiences: [],
  skills: [],
  loading: false,
  error: {}
};

const Profile = createSlice({
  name: 'Profile',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getProfile.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getProfile.fulfilled, (state, action) => {
      state.profile = action.payload[0] || {};
      state.loading = false;
    });

    builder.addCase(getProfile.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.profile = action.payload[0] || {};
    });

    builder.addCase(updateProfile.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateProfilePicture.fulfilled, (state, action) => {
      state.profile = action.payload[0] || {};
    });

    builder.addCase(updateProfilePicture.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getExperience.fulfilled, (state, action) => {
      state.experiences = action.payload;
    });

    builder.addCase(getExperience.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

     builder.addCase(addExperience.fulfilled, (state, action) => {
       console.log('action.payload: ', action.payload);
      state.experiences = [action.payload[0], ...state.experiences];
    });

    builder.addCase(addExperience.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

     builder.addCase(updateExperience.fulfilled, (state, action) => {
      state.experiences = state.experiences.map((item) => item.ID === action.payload[0].ID ? action.payload[0] : item);
    });

    builder.addCase(updateExperience.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

     builder.addCase(deleteExperience.fulfilled, (state, action) => {
      state.experiences = state.experiences.filter((item) => item.ID !== action.payload[0].ID);
    });

    builder.addCase(deleteExperience.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getSkills.fulfilled, (state, action) => {
      state.skills = action.payload;
    });

    builder.addCase(getSkills.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

     builder.addCase(addSkills.fulfilled, (state, action) => {
      state.skills = [action.payload[0], ...state.skills];
    });

    builder.addCase(addSkills.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

     builder.addCase(updateSkills.fulfilled, (state, action) => {
      state.skills = state.skills.map((item) => item.ID === action.payload[0].ID ? action.payload[0] : item);
    });

    builder.addCase(updateSkills.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

     builder.addCase(deleteSkills.fulfilled, (state, action) => {
      state.skills = state.skills.filter((item) => item.ID !== action.payload[0].ID);
    });

    builder.addCase(deleteSkills.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(verifyOTP.fulfilled, (state, action) => {
      state.profile = action.payload[0] || {};
    });

    builder.addCase(verifyOTP.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Profile.reducer;